module.exports = __webpack_public_path__ + "static/super-admin-withdrawal-list-613b5a6a5064bd4f7cfb376ed82f35ed.png";